// src/components/TestimonialCarousel.jsx
import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Mousewheel, Keyboard } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "../TestimonialCarousel.css"; // Custom styles

const testimonials = [
    {
        name: "Jane Doe",
        designation: "CEO",
        info:
            "Working with this team was an absolute pleasure. They understood our vision from the start and delivered a product that exceeded expectations.",
        profile:
            "https://randomuser.me/api/portraits/women/30.jpg",
        review:
            "https://randomuser.me/api/portraits/women/31.jpg",
    },
    {
        name: "John Smith",
        designation: "CTO",
        info:
            "Their technical expertise and responsiveness made a huge difference in our project timeline. We were able to launch weeks ahead of schedule.",
        profile:
            "https://randomuser.me/api/portraits/men/32.jpg",
        review:
            "https://randomuser.me/api/portraits/men/33.jpg",
    },
    {
        name: "Emily Davis",
        designation: "Product Manager",
        info:
            "From wireframes to the final product, the attention to user experience was impressive. Our customers love the new interface!",
        profile:
            "https://randomuser.me/api/portraits/women/34.jpg",
        review:
            "https://randomuser.me/api/portraits/women/35.jpg",
    },
    {
        name: "Liam Bennett",
        designation: "Senior UX Designer",
        info:
            "I appreciated how collaborative the process was. Every feedback loop felt like a genuine conversation, and the final outcome speaks for itself.",
        profile:
            "https://randomuser.me/api/portraits/men/36.jpg",
        review:
            "https://randomuser.me/api/portraits/men/37.jpg",
    },
    {
        name: "Ava Richardson",
        designation: "AI Research Scientist",
        info:
            "Their work on our AI model optimization helped us reduce inference time by nearly 40%. This has had a direct impact on our deployment efficiency.",
        profile:
            "https://randomuser.me/api/portraits/women/38.jpg",
        review:
            "https://randomuser.me/api/portraits/women/39.jpg",
    },
    {
        name: "Noah Carter",
        designation: "DevOps Engineer",
        info:
            "The migration to cloud infrastructure went smoother than I expected. Their knowledge of CI/CD pipelines saved us countless hours of trial and error.",
        profile:
            "https://randomuser.me/api/portraits/men/40.jpg",
        review:
            "https://randomuser.me/api/portraits/men/41.jpg",
    },
    {
        name: "Sophia Martin",
        designation: "Marketing Lead",
        info:
            "Our digital campaign results skyrocketed after implementing their strategy. They truly understand how to align creative work with data insights.",
        profile:
            "https://randomuser.me/api/portraits/women/42.jpg",
        review:
            "https://randomuser.me/api/portraits/women/43.jpg",
    },
    {
        name: "Elijah Brooks",
        designation: "Software Engineer",
        info:
            "Clean code, fast turnarounds, and clear communication — it’s rare to find a team this reliable. I’d absolutely work with them again.",
        profile:
            "https://randomuser.me/api/portraits/men/44.jpg",
        review:
            "https://randomuser.me/api/portraits/men/45.jpg",
    }
];

const TestimonialCarousel = () => {
    return (
        <div className=" bg">
            {/* Navigation Buttons */}
            <div className="btn">
                <div className="swiper-button-prevs">
                    <img
                        className="image-block pagination-button"
                        src="https://workik-widget-assets.s3.amazonaws.com/widget-assets/images/t33.png"
                        alt="Previous"
                    />
                </div>
                <div className=" swiper-button-nexts">
                    <img
                        className="image-block pagination-button"
                        src="https://workik-widget-assets.s3.amazonaws.com/widget-assets/images/t32.png"
                        alt="Next"
                    />
                </div>
            </div>

            {/* Swiper Carousel */}
            <Swiper
                slidesPerView={3}
                spaceBetween={10}
                pagination={{ clickable: true, el: ".swiper-pagination" }}
                navigation={{
                    nextEl: ".swiper-button-nexts",
                    prevEl: ".swiper-button-prevs",
                }}
                mousewheel
                keyboard
                loop
                modules={[Navigation, Pagination, Mousewheel, Keyboard]}
                breakpoints={{
                    300: { slidesPerView: 1 },
                    501: { slidesPerView: 1 },
                    769: { slidesPerView: 3 },
                    1025: { slidesPerView: 3 },
                }}
                className="mySwiper swiper-container"
            >
                {testimonials.map((item, index) => (
                    <SwiperSlide key={index} className="swiper-slide">
                        <div className="responsive-container-block content">
                            <p className="text-blk quotes">“</p>
                            <img className="profile-img p-2" src={item.profile} alt="Profile" />
                            <p className="text-blk info p-2">{item.info}</p>
                            <p className="text-blk name p-2">{item.name}</p>
                            <p className="text-blk desig">{item.designation}</p>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>

            <div className="swiper-pagination container-block"></div>
        </div>
    );
};

export default TestimonialCarousel;
